import { ApplicationJson } from '../base/httpclient';
import AuthApi from './_authApi';

class AccountApi extends AuthApi {
  constructor() {
    super();
  }
  controllerName = 'Accounts';

  // [kbnguyet - 2026-05-14] Sửa: nhận model thay vì hardcode username/password
  login(model) {
    const param = {url: [this.getAPIUrl(), 'login'].join('/'), data: model};
    return this.postAsync(param);
  }

  logout() {
    const param = {url: [this.getAPIUrl(), 'logout'].join('/')};
    return this.postAsync(param, true, true, ApplicationJson);
  }

  logoutWithoutRedirect() {
    const param = {url: `${window.location.origin}/APIS/AuthenAPI/api/Account/logoutwithoutredirect`};
    return this.getAsync(param, false, false, ApplicationJson, false);
  }
  /**
   * Đăng nhập
   */
  async loginCallback(model) {
    const request = {
      url: [this.getAPIUrl(), 'login-callback'].join('/'),
      data: model,
    };
    return this.getAsync(request, true, true, ApplicationJson, false);
  }
  /**
   * Tạo id token với mã ứng dụng con
   * @param {*} appCode
   * @returns Promise
   */
  async createIdTokenForSubApp(payload) {
    const request = {
      url: [this.getAPIUrl(), 'id-token'].join('/'),
      data: payload,
    };
    return this.postAsync(request, true, true, ApplicationJson, false);
  }
  /**
   * Tạo id token với mã ứng dụng con
   * @param {*} appCode
   * @returns Promise
   */
  async createAmisToken(appCode) {
    const request = {
      url: [this.getAPIUrl(), 'amis-token'].join('/'),
      data: {appCode},
    };
    return this.postAsync(request, true, true, ApplicationJson, false);
  }

  // Gọi lấy amisToken truyền đẩy đủ payload hơn
  // nttung10-27/7/2026
  async createAmisTokenCustom(payload) {
    const request = {
      url: [this.getAPIUrl(), 'amis-token'].join('/'),
      data: payload,
    };
    return this.postAsync(request, true, true, ApplicationJson, false);
  }
  /**
   * @description:  lấy thông tin tài khoản misa id
   * @param: {any}
   * @return: {any}
   * CreatedBy: KBNGUYET 06/05/2025
   */
  async getMisaIdData() {
    const request = {
      url: [this.getAPIUrl(), 'data-misa-id'].join('/'),
    };
    return this.getAsync(request);
  }
  /**
   * @description: Get link từ MisaID
   * @param: {any}
   * @return: {any}
   * CreatedBy: KBNGUYET 06/05/2025
   */
  async getMisaIdLink(payload) {
    const request = {
      url: [this.getAPIUrl(), 'get-misa-id-link'].join('/'),
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * Lấy thông tin ứng dụng theo appCode
   * @param {string} appCode Mã ứng dụng
   * @returns Promise Thông tin ứng dụng
   * CreatedBy: Cline 11/05/2025
   */
  async getAppInfo(appCode) {
    const request = {
      url: [this.getAPIUrl(), 'app-info', appCode].join('/'),
    };
    return this.getAsync(request, true, true, ApplicationJson, false);
  }

  /**
   * Xác nhận thỏa thuận mua hàng, sử dụng dịch vụ và chính sách quyền riêng tư
   * @param {boolean} isAcceptPurchase - Xác nhận thỏa thuận mua hàng
   * @returns {Promise<Object>}
   */
  async acceptAgreementTermsPrivacy(isAcceptPurchase) {
    const request = {
      url: [this.getAPIUrl(), `agreements-purchase?isAcceptPurchase=${isAcceptPurchase}`].join('/'),
    };
    return this.postAsync(request, true, true, ApplicationJson, false);
  }

  async executeAfterLogin() {
    const request = {
      url: [this.getAPIUrl(), 'execute-after-login'].join('/'),
    };
    return this.getAsync(request, true, true, ApplicationJson, false);
  }

  async switchOrganization(payload){
    const request = {
      url: [this.getAPIUrl(), 'switch-organization'].join('/'),
      data: payload,
    };
    return this.postAsync(request, true, true, ApplicationJson, false);
  }
  async getTenants(){
    const request = {
      url: [this.getAPIUrl(), 'tenants'].join('/'),
    };
    return this.getAsync(request, true, true, ApplicationJson, false);
  }
}

export default new AccountApi();
